import { Page, PageHeader } from '@/shared/ui/page';
import { Text } from '@noorden-insurtech/alba-design-system';
import { Home, PackageX } from 'lucide-react';
import { useBrokerContext } from '../../../app/context';
import { BrokerWriteGate } from '../../brokers/components/broker-write-gate.component';
import {
  useBrokerProducts,
  useSelectedBrokerWriteGuard,
} from '../../brokers/hooks';
import { ProductsGridSkeleton } from './products-grid-skeleton.component';
import { ProductsGrid } from './products-grid.component';

export function ChooseProductPage() {
  const { selectedBroker } = useBrokerContext();
  const { data: brokerProducts, isLoading } = useBrokerProducts(
    selectedBroker?.code
  );

  const activeProducts = (brokerProducts?.data ?? []).filter(
    product => product.status === 'active'
  );
  const hasNoActiveProducts = !isLoading && activeProducts.length === 0;
  const quoteWriteGuard = useSelectedBrokerWriteGuard('quote');

  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          {
            label: 'Página Inicial',
            href: '/dashboard',
            iconLeft: <Home className='h-4 w-4' />,
          },
          { label: 'Cotações' },
          { label: 'Escolher Produto', active: true },
        ]}
      />

      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.TitleGroup>
            <PageHeader.Title>Escolha o Produto</PageHeader.Title>
            <PageHeader.Subtitle>
              Selecione o seguro que melhor atende suas necessidade
            </PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>

      <Page.Content className='mt-6'>
        <BrokerWriteGate guard={quoteWriteGuard} backTo='/quotes'>
          {isLoading ? (
            <ProductsGridSkeleton />
          ) : hasNoActiveProducts ? (
            <div className='flex flex-col items-center justify-center rounded-xl border border-alba-gray-200 bg-alba-gray-50 px-8 py-16 text-center'>
              <PackageX className='mb-4 h-16 w-16 text-alba-gray-400' />
              <Text className='mb-2 font-gotham text-lg font-bold text-alba-black-500'>
                Nenhum produto ativo disponível
              </Text>
              <Text className='max-w-md text-alba-gray-600'>
                Não há produtos cadastrados para este corretor. Solicite o
                cadastro de produtos ao administrador da conta.
              </Text>
            </div>
          ) : (
            <ProductsGrid products={activeProducts} />
          )}
        </BrokerWriteGate>
      </Page.Content>
    </Page.Root>
  );
}
